import axios from 'axios'
import { publishTencentQuote, quoteRequestStamp } from './stockQuoteFeed'

const quotes = new Map(), pending = new Map()
const QUOTE_REUSE_MS = 1000

export async function getStockQuotes(codes) {
  const requested = [...new Set(String(codes || '').split(',').map(code => code.trim()).filter(Boolean))]
  if (!requested.length) throw new Error('请选择行情代码')
  if (requested.some(code => !/^(?:(?:s_)?(?:sh|sz|bj)\d{6}|(?:(?:s_)?r_)?hk[A-Za-z0-9]{3,12}|(?:t_)?us\.?[A-Za-z0-9][A-Za-z0-9._-]{0,39})$/i.test(code))) throw new Error('无效的行情代码')
  const now = Date.now()
  for (const [code, quote] of quotes) if (now - quote.at >= QUOTE_REUSE_MS) quotes.delete(code)
  const missing = requested.filter(code => !quotes.has(code) && !pending.has(code))
  // Keep public result keys unchanged; only transport symbols carry realtime prefixes.
  const symbolOf = code => /^hk/i.test(code) ? 'r_' + code : /^us/i.test(code) ? 't_' + code : code
  const isForeign = code => /^(?:(?:(?:s_)?r_)?hk|(?:t_)?us)/i.test(code)
  const groups = [missing.filter(code => !isForeign(code)), missing.filter(isForeign)]
  for (const [groupIndex, group] of groups.entries()) {
    for (let offset = 0; offset < group.length; offset += 100) {
      const batchCodes = group.slice(offset, offset + 100)
      const symbols = [...new Set(batchCodes.map(symbolOf))]
      const url = groupIndex === 0 ? 'https://qt.gtimg.cn/' : 'https://sqt.gtimg.cn/q=' + symbols.join(',')
      const stamp = quoteRequestStamp()
      const batch = axios.get(url, { ...(groupIndex === 0 ? { params: { q: symbols.join(',') } } : {}), timeout: 15000, responseType: 'text' }).then(response => {
        const data = {}
        String(response.data).replace(/v_([^=]+)="([^"]*)";?/g, (_, code, value) => { data[code] = value.split('~'); publishTencentQuote(code, data[code], stamp); return '' })
        if (!Object.keys(data).length) throw new Error('行情接口返回格式异常')
        return data
      })
      for (const code of batchCodes) {
        const task = batch.then(data => {
          // Measure freshness from request start; a slow response must not extend quote reuse.
          const value = data[symbolOf(code)]
          if (value) quotes.set(code, { value, at: now })
          return value
        }).finally(() => pending.delete(code))
        pending.set(code, task)
      }
    }
  }
  const rows = await Promise.all(requested.map(async code => {
    const quote = quotes.get(code)
    const row = quote ? quote.value : await pending.get(code)
    // Callers may mutate their copy without changing the shared quote snapshot.
    return row ? [code, row.slice()] : null
  }))
  return Object.fromEntries(rows.filter(Boolean))
}
